(ns hai.entity.draft
  "What a composer holds that isn't filed yet, kept in app-db under one key and
   addressed by a `draft-id` its host picks.

   Two composers on the same `draft-id` are two views on one draft, not copies
   handed between them: the home pad and the expanded editor it opens are one
   editing session, so opening it carries nothing and closing it hands nothing
   back. A draft also outlives the composer, so an editor unmounted from under
   the writer — a list reloading, a dialog closing — doesn't take the writing
   with it.

   Hosts seed on the flow that opens an editor and discard on the one that
   leaves it, the way they dispatch their loads; a composer never writes its
   own draft into existence."
  (:require
   [hai.ui.rf-sugar :refer [defevent defsub]]))

;; Written as functions as well as events: a host seeding or reading a draft is
;; usually doing it as part of a larger db change, and threading it through
;; reads better than queueing a second event to land after the first.

(defn current
  "The draft at `draft-id` — for an event that acts on what a composer holds
   (＋ filing the pad, a save reading it back). Views deref [[::draft]]."
  [db draft-id]
  (get-in db [::drafts draft-id]))

(defn seed
  "Write `payload` as the draft at `draft-id`. Seeding is also re-seeding:
   Cancel puts the entity as filed back, ＋ puts a blank one there."
  [db draft-id payload]
  (assoc-in db [::drafts draft-id] payload))

(defn discard
  [db draft-id]
  (-> db
      (update ::drafts dissoc draft-id)
      (update ::carets dissoc draft-id)))

(defsub ::draft [db draft-id]
  (current db draft-id))

(defevent ::seed [db draft-id payload]
  (seed db draft-id payload))

(defevent ::change [db draft-id changes]
  (update-in db [::drafts draft-id] merge changes))

(defevent ::discard [db draft-id]
  (discard db draft-id))

;; The caret sits beside the draft rather than in it: a composer taking over
;; from another wants to open where the writer left off, but where the cursor
;; is says nothing about whether there is anything to file — and a draft that
;; changed only because the caret moved would read as unsaved work.
(defsub ::caret [db draft-id]
  (get-in db [::carets draft-id]))

(defevent ::caret-moved [db draft-id position]
  (assoc-in db [::carets draft-id] position))
